/** Поръчка: план, данни за контакт, адрес за фактуриране и обобщение. */
export default {
  title: "Поръчка",
  intro:
    "Потвърдете плана и данните за фактуриране. След това ще изберете Банка ДСК или Пощенска банка на страницата за плащане.",
  plan: {
    title: "Вашият план",
    subtitle: "Ако сте избрали грешен план, можете да го смените тук.",
  },
  contact: {
    title: "Данни за контакт",
    subtitle: "Тук ще изпращаме разписката и известията за поръчката.",
    creditsNote: "Точките се добавят към профила с този имейл.",
  },
  billing: {
    title: "Адрес за фактуриране",
    subtitle: "Този адрес се изписва във фактурата и се проверява от банката.",
  },
  fields: {
    fullName: "Име и фамилия",
    email: "Имейл",
    phone: "Телефон",
    company: "Фирма",
    addressLine1: "Адрес",
    addressLine2: "Апартамент, етаж, вход",
    city: "Град",
    postalCode: "Пощенски код",
    country: "Държава",
    optional: "(по избор)",
  },
  placeholders: {
    company: "Име на фирмата за фактурата",
    addressLine1: "Улица и номер",
    addressLine2: "Вход Б, етаж 1, апартамент 34",
  },
  errors: {
    acceptTerms: "Моля, потвърдете, че сте навършили 18 години и приемате Общите условия, Политиката за възстановяване на суми и Политиката за доставка.",
    fullNameRequired: "Моля, въведете име и фамилия.",
    emailRequired: "Моля, въведете имейл адрес.",
    emailInvalid: "Моля, въведете валиден имейл адрес.",
    phoneRequired: "Моля, въведете телефонен номер.",
    phoneInvalid: "Моля, въведете валиден телефонен номер.",
    addressLine1Required: "Моля, въведете адрес.",
    cityRequired: "Моля, въведете град.",
    postalCodeRequired: "Моля, въведете пощенски код.",
    countryRequired: "Моля, изберете държава.",
    startFailed: "Поръчката не можа да започне.",
  },
  custom: {
    name: "Персонален",
    yourPrice: "Вашата цена",
    priceLabel: "Вашата цена (€)",
    planName: "Персонален план на Media-Style",
    credits_one: "{{formatted}} точка",
    credits_other: "{{formatted}} точки",
    summary_one: "{{formatted}} точка с предимствата на {{level}}.",
    summary_other: "{{formatted}} точки с предимствата на {{level}}.",
    levelBenefits: "Предимства на {{level}}",
  },
  summary: {
    title: "Обобщение на поръчката",
    planName: "План {{plan}} на Media-Style",
    billing: "{{credits}} · Еднократно плащане",
    subtotal: "Междинна сума",
    taxes: "Данъци",
    included: "Включени",
    totalDueToday: "Общо за плащане",
  },
  promo: {
    label: "Промо код",
    placeholder: "Въведете код",
    apply: "Приложи",
    applying: "Проверка…",
    remove: "Премахни",
    applied: "Кодът {{code}} е приложен",
    discount: "Отстъпка ({{code}})",
    errors: {
      invalid: "Този промо код не е валиден.",
      not_started: "Този промо код все още не е активен.",
      expired: "Този промо код е изтекъл.",
      used_up: "Този промо код е достигнал лимита си на използване.",
      min_order: "Този промо код изисква поръчка от поне {{amount}}.",
      failed: "Промо кодът не можа да бъде проверен. Моля, опитайте отново.",
    },
  },
  orderNow: "Поръчайте · {{price}}",
  reviewOrder: "Преглед на поръчката",
  reviewNext: "Ще прегледате поръчката си преди плащане",
  review: {
    title: "Прегледайте поръчката си",
    intro: "Проверете всичко по-долу, преди да платите. Не се изтегля сума, докато не завършите плащането на страницата на банката.",
    edit: "Редактиране",
    plan: "План",
    total: "Общо",
    totalNote: "· еднократно плащане, всички данъци са включени",
    contact: "Данни за контакт",
    billing: "Адрес за фактуриране",
    notice:
      "С натискането на „Поръчайте“ правите поръчка със задължение за плащане. След това избирате банка и плащате на нейната защитена страница. Разписката ви се изпраща по имейл веднага щом плащането бъде потвърдено.",
  },
  opening: "Отваряне на плащането…",
  chooseBankNext: "В следващата стъпка ще изберете банка",
  acceptTerms:
    "Потвърждавам, че съм навършил(а) 18 години и приемам <terms>Общите условия</terms>, <refund>Политиката за възстановяване на суми</refund> и <delivery>Политиката за доставка</delivery>.",
  /** Само за показване; към банката се изпраща английското име. */
  countries: {
    Bulgaria: "България",
    Austria: "Австрия",
    Belgium: "Белгия",
    Croatia: "Хърватия",
    Cyprus: "Кипър",
    Czechia: "Чехия",
    Denmark: "Дания",
    Estonia: "Естония",
    Finland: "Финландия",
    France: "Франция",
    Germany: "Германия",
    Greece: "Гърция",
    Hungary: "Унгария",
    Ireland: "Ирландия",
    Italy: "Италия",
    Latvia: "Латвия",
    Lithuania: "Литва",
    Luxembourg: "Люксембург",
    Malta: "Малта",
    Netherlands: "Нидерландия",
    Norway: "Норвегия",
    Poland: "Полша",
    Portugal: "Португалия",
    Romania: "Румъния",
    Slovakia: "Словакия",
    Slovenia: "Словения",
    Spain: "Испания",
    Sweden: "Швеция",
    Switzerland: "Швейцария",
    "United Kingdom": "Обединеното кралство",
    "United States": "Съединените щати",
    Canada: "Канада",
    Australia: "Австралия",
  },
};
